import type { BaseDataItem } from '@wix/thunderbolt-becky-types'
import { createDataNode, envRefs } from '@wix/thunderbolt-catharsis'

const WidgetRef = createDataNode({
	getDependencies: (compData: BaseDataItem & { widgetId: string }) =>
		compData.widgetId ? envRefs.presetsCss(compData.widgetId) : undefined,
	toViewItem: (item, schemaDeps, resolvedWidgetPresets) => {
		const resolvedData = {
			...item,
			...(schemaDeps as any),
		}
		if (resolvedWidgetPresets) {
			resolvedData.resolvedWidgetPresets = resolvedWidgetPresets
		}
		return resolvedData
	},
})

export { WidgetRef }
